
        Component.define('header', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);
const $wrapScale = $('.wrap-scale');

TweenMax.set($window, {
    scrollTo: { y: 0, autoKill: false },
});

let lastScrollTop = $window.scrollTop();
let direction = '';
let timeout;

const hide = (delay = 1500) => {
    if (direction !== 'down') {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            direction = 'down';
            TweenMax.to($el, .8, { top: 0, ease: wW <= 768 ? Expo.easeOut : Power2.easeOut });
        }, delay);
    }
};

const show = () => {
    if (direction !== 'up') {
        direction = 'up';

        const height = $el.find('.main-menu').innerHeight();

        clearTimeout(timeout);
        TweenMax.to($el, .8, { top: height * 0.90, ease: wW <= 768 ? Expo.easeOut : Power2.easeOut });
    }
};

$el.on('mouseenter mousemove', function () {
    if ($el.is('.menu-fixed')) {
        show();
    }
});

$el.on('mouseleave', function () {
    if ($el.is('.menu-fixed')) {
        hide(0);
    }
});

$window.on('scroll.header', function () {
    const scrollTop = $window.scrollTop();
    const top       = Math.floor($el.find('.main-menu').offset().top - $el.offset().top);
    const height    = $el.find('.main-menu').innerHeight() - 15;

    if (scrollTop >= (direction == 'up' ? top : top + height)) {
        $el.addClass('menu-fixed');

        TweenMax.set($el, { y: -top -height});

        if (lastScrollTop < scrollTop) {
            hide(0);
        } else {
            hide(0);
            // show();
            // hide(1500);
        }
    } else {
        $el.removeClass('menu-fixed');

        direction = '';

        if (lastScrollTop != scrollTop) {
            clearTimeout(timeout);
        }

        TweenMax.set($el, { y: 0, top: 0 });
    }

    lastScrollTop = scrollTop;
});

$window.on('resize.header', function () {
    const $parent = $el.parent();
    const h = $el.height();

    TweenMax.set($parent, { paddingTop: h });
});

$window.trigger('resize');

if (!sessionStorage.getItem('first-access')) {
    sessionStorage.setItem('first-access', true);

    TweenMax.killTweensOf($window);
    TweenMax.set($window, {
        scrollTo: { y: $el.find('.main-menu').offset().top - $el.offset().top, autoKill: false },
    });

    $window.trigger('scroll');

    timeout = setTimeout(() => {
        TweenMax.to($window, .8, {
            scrollTo: { y: $el.find('.main-menu').offset().top - $el.offset().top + $el.find('.main-menu').innerHeight() - 15, autoKill: false },
        });
    }, 2500);
} else {
    TweenMax.set($window, {
        scrollTo: { y: $el.find('.main-menu').offset().top - $el.offset().top + $el.find('.main-menu').innerHeight() - 15, autoKill: false },
    });
}

        });